import ApiUrl from "../../configTools/apiUrls";
const CodeSend = async (contact,callback) => {
    let res = await fetch(ApiUrl.API_URL_MobileVerification+'/sendcode', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          phone: contact
        })
    })
    res = await res.json();
    if(res.success){
        callback(true);
    }
    else{
        callback(false);
        alert(res.responce)
    }
}

const VerifyCode = async (contact,contactcode,callback) =>{
    let res = await fetch(ApiUrl.API_URL_MobileVerification+'/verifycode', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          phone: contact,
          token: contactcode
        })
    })
    res = await res.json();
    if(res.success){
        callback(true);
    }
    else{
        callback(false);
        alert(res.responce)
    }
}

const SubmitRegistration = async (body,callback)=>{
    let res = await fetch(ApiUrl.API_URL_OAuth+'/register', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    })
    res = await res.json();
    if(res.success){
        callback(true)
    }
    else{
        alert(res.responce);
    }
}

export default {CodeSend,VerifyCode,SubmitRegistration}